import { render } from "./SvgImage.vue?vue&type=template&id=18e63b76&scoped=true"
import script from "./SvgImage.vue?vue&type=script&lang=js"
export * from "./SvgImage.vue?vue&type=script&lang=js"

import "./SvgImage.vue?vue&type=style&index=0&id=18e63b76&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\forome\\site-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e63b76"]])

export default __exports__